import './instance';

// register create function for bundleid
Oskari.bundle('routingService', function () {
  return Oskari.clazz.create('Oskari.mapframework.bundle.routingService.RoutingServiceBundleInstance');
});